export const routes = {
    any: '*',
    main: '/',
};
